import React from 'react';
import PropTypes from 'prop-types';

// components
import ComponentLoader from '../../../global/ComponentLoader/ComponentLoader';

function importFunc() {
    return import(/* webpackChunkName: "PdpRespNotificationMultiplePdpVisitsModal" */
    './PdpSharedNotificationMultiplePdpVisitsModal').then(moduleExport => moduleExport.default);
}

const PdpRespNotificationMultiplePdpVisitsModalLoader = props => {
    return (
        <ComponentLoader
            {...props}
            useLoadingComponent={false}
            importFunc={importFunc}
            load={props.isEnabled}
        />
    );
};

PdpRespNotificationMultiplePdpVisitsModalLoader.propTypes = {
    environment: PropTypes.object.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
};

export default PdpRespNotificationMultiplePdpVisitsModalLoader;
